export default __webpack_public_path__ + "static/media/undereyeDarknessActive.3a9910a1.svg";